var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SocialApple",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8860262,1.82747018 C14.2658139,0.00890052115 16.1840832,0 16.1840832,0 C16.1840832,0 16.4693484,1.70979701 15.0986681,3.3568764 C13.6350499,5.11559178 11.9714114,4.82780826 11.9714114,4.82780826 C11.9714114,4.82780826 11.6590652,3.44463968 12.8860262,1.82747018 M12.1469103,6.02552863 C12.8567787,6.02552863 14.1741593,5.04978312 15.8889585,5.04978312 C18.8406887,5.04978312 20.0018617,7.15013362 20.0018617,7.15013362 C20.0018617,7.15013362 17.7307454,8.31127215 17.7307454,11.1288046 C17.7307454,14.3072221 20.5599037,15.4026071 20.5599037,15.4026071 C20.5599037,15.4026071 18.5821941,20.9691587 15.9108993,20.9691587 C14.6839384,20.9691587 13.7301337,20.1423071 12.4373502,20.1423071 C11.1199696,20.1423071 9.81259343,21 8.96114474,21 C6.52181548,21 3.44009627,15.7196106 3.44009627,11.4750969 C3.44009627,7.29899311 6.04860444,5.10829197 8.49524731,5.10829197 C10.0857497,5.10829197 11.3200243,6.02552863 12.1469103,6.02552863",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialApple);
export default __webpack_public_path__ + "static/media/SocialApple.351da2659ce910e5811e8b992f546e38.svg";
export { ForwardRef as ReactComponent };